import React from 'react';
import './home.css';
import Hero from '../../singles/hero/Hero';
import TrustedBy from '../../singles/trustedBy/TrustedBy';
import Unique from '../../singles/Unique/Unique';
import VirtualCard from '../../singles/VirtualCard/VirtualCard';
import Testimonial from '../../singles/Testimonial/Testimonial';
import CallToAction from '../../singles/call-to-action/Call-to-action';
import Footer from '../../singles/footer/Footer';

export default function Home() {
  return (
    <div className='home-container'>
      <Hero />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#023e8a" fill-opacity="1" d="M0,96L40,106.7C80,117,160,139,240,160C320,181,400,203,480,176C560,149,640,75,720,58.7C800,43,880,85,960,112C1040,139,1120,149,1200,133.3C1280,117,1360,75,1400,53.3L1440,32L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path></svg>
      <TrustedBy />
      <Unique />
      <VirtualCard />
      <Testimonial />
      <CallToAction />
      <Footer />
    </div>
  )
}
